import { tranlateInvalidInputs, formatInputsOnMessage, is2xxStatus } from './AlertMessageLogic'

export default function messageOnSubmitNewUser(status, invalidInputs) {
    let message, inputs

    invalidInputs = tranlateInvalidInputs(invalidInputs)
    inputs = formatInputsOnMessage(invalidInputs)

    if (is2xxStatus(status)) status = '2xx'

    switch (status) {
        case 503:
            message = 'Ops! Ocorreu um problema com a internet e não conseguimos criar um usuário.'
            break
        case 'invalid':
            message = `Ops! Ocorreu um problema e não criamos o usuário. Veja se preencheu ${
                inputs.length > 1 ? 'os campos' : 'o campo'
            } ${inputs} corretamente.`
            break
        case '2xx':
            message = 'Criamos um usuário.'
            break
        case 400:
            message =
                'Ops! Ocorreu um problema e não criamos o usuário. Veja se preencheu todos os campos obrigatórios.'
            break
        case 401:
            message = 'Ops! O seu tempo de acesso expirou, para criar um usuário é necessário realizar o login.'
            break
        case 403:
            message = 'Permissão Negada.'
            break
        case 500:
        default:
            message = 'Ops! Algo estranho ocorreu e não registramos o eitri-app. Por favor, tente novamente mais tarde.'
    }

    return message
}
